<template>
  <div class="wapper" v-if="isShow">
    <div class="header">
      <span class="icontemp stemp-close" @click="close"></span>
      问卷
    </div>
    <div class="content" style="padding: 0">
      <iframe
        :src="src"
        style="height: 100%;width: 100%;"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
// import {ck, $subscriber } from "fire-wind-water";
// import ws from "../../services/webinar";
import {
  buildQuestionData,
  buildQuestionMethod,
  mounted
} from "../../common/question";
export default {
  name: "Question",
  data() {
    return buildQuestionData({
      type: "wap"
    });
  },
  created() {
    let self = this;
    mounted(self);
  },
  methods: buildQuestionMethod({})
};
</script>

<style scoped></style>
